import { useState } from "react";

function useElementVisible(initialState) {
    const [state, setState] = useState(initialState)
    const setElemVisible = key => {
        if (state[key] === true) return
        setState({ ...state, [key]: true })
    }
    return [state, setElemVisible]
}

export default useElementVisible